module.exports = __webpack_public_path__ + "static/logo_hera_mi_nb-bb013ce42b016a6a4bbd92f2078433bf.svg";